import { select as d3_select } from 'd3-selection'

let delayedEraser

function TooltipBehavior(chart, config = {}) {
  // console.log("config",config)
  let tooltipData = []
  let tooltipRoot = d3_select(chart.$root.parentNode)

  let updateTooltip = function(itemsKey) {
    chart.config.TooltipBehavior.beforeUpdate(tooltipData[0]?.datum)

    //Bastante guarrero, pero efectivo...
    if (!chart.config.TooltipBehavior.enableTooltips) tooltipData = []

    let tooltip = tooltipRoot.selectAll('.tooltip').data(tooltipData)

    config.persistent !== true && tooltip.exit().remove()

    let tooltipEnter = tooltip
      .enter()
      .append('div')
      .attr('class', 'tooltip')
      .classed('hoverable', chart.config.TooltipBehavior.allowMouseEvents)
      .style('opacity', 0)
      .style('color', '#444')

    if (config.persistent) {
      tooltipEnter.on('mouseleave', () => {
        tooltipData = []
        tooltipRoot.selectAll('.tooltip').remove()
      })
      tooltipEnter.on('mouseenter', () => {
        clearTimeout(delayedEraser)
      })
    }

    tooltipEnter
      .transition()
      .duration(200)
      .style('opacity', 1)

    tooltipEnter.style('position', 'absolute')

    tooltipEnter
      .append('div')
      .attr('class', 'content')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('transform', 'translate(-50%,-5px)')
      .style('background', '#fff')
      // .style('border', 'solid 1px #aaa')
      .style('border-radius', '3px')
      // .style('padding', '3px')
      // .style('text-align', 'center')
      .style('white-space', 'wrap')
      .style('font-size', `${chart.config.TooltipBehavior.fontSize || 10}px`)
      // .style('max-width', '180px')
      // .style('line-height', '1.4em')
      // .style('box-shadow', '1px 3px 11px #ddd')
      .append('div')
      .attr('class', 'content-wrapper')
    // .style('width', 'max-content')
    // .style('max-width', '100%')
    // .style('word-wrap', 'break-word')

    tooltipEnter
      .append('div')
      .attr('class', 'tip-border')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('transform', 'translate(-50%,0px)')
      .style('width', 0)
      .style('height', 0)
      .style('border-left', '6px solid transparent')
      .style('border-right', '6px solid transparent')
    // .style('border-top', '6px solid #aaa')
    tooltipEnter
      .append('div')
      .attr('class', 'tip')
      .style('position', 'absolute')
      .style('bottom', 0)
      .style('transform', 'translate(-50%,-1px)')
      .style('width', 0)
      .style('height', 0)
      .style('border-left', '5px solid transparent')
      .style('border-right', '5px solid transparent')
      .style('border-top', '5px solid #fff')

    tooltip = tooltip.merge(tooltipEnter)
    tooltip.style('top', d => `${d.pos.top}px`).style('left', d => `${d.pos.left}px`)

    tooltip
      .select('.content')
      .select('.content-wrapper')
      .html(d => {
        return config.getHtml.call(chart, d.datum, itemsKey)
      })
      .selectAll('.important')
    // .style('font-size', '14px')
    // .style('line-height', '1.8em')
  }
  d3_select(chart.$root).on('mouseover', () => {
    tooltipData = []
    updateTooltip()
    // }
  })

  let itemsKeys = chart.config.TooltipBehavior.itemsKeys

  if (itemsKeys.length === 0) {
    console.warn('Chart doesnt have .items to add tooltips to')
    return
  }
  itemsKeys.forEach(key => {
    let items = chart[key + 'Enter']
    if (config.persistent === true) {
      items.on('mouseleave', () => {
        delayedEraser = setTimeout(() => {
          tooltipData = []
          tooltipRoot.selectAll('.tooltip').remove()
        }, 500)
      })
      items.on('mouseenter', () => {
        clearTimeout(delayedEraser)
      })
    }
    items.on('mousemove', (ev, d) => {
      if (config.hasTooltip && !config.hasTooltip(d)) return
      let offset = tooltipRoot.node().getBoundingClientRect()
      let targetPos = chart.config.TooltipBehavior.getItemOffset.call(chart, ev.currentTarget, d)
      tooltipData = [
        {
          datum: d,
          pos: { top: targetPos.y - offset.y, left: targetPos.x - offset.x },
        },
      ]
      updateTooltip(key)
    })
    //update "siempre" que cambie cualquier PROP o incluso el DATA, no?
    updateTooltip(key)
  })
}

TooltipBehavior.defaultConfig = {
  index: 202,
  itemsKeys: {
    type: [String, Array],
    default: ['items'],
  },
  /**
   * Enable/disable tooltips. When enabled tooltips will popup when items are hovered (tapped on mobile).
   */
  enableTooltips: {
    type: Boolean,
    default: true,
    exposed: true,
  },
  getHtml: {
    type: Function,
    default: function(d) {
      return `
        <p class="important">${this.valueWithUnit(d.value)}</p>
        <p>${d.label}</p>
      `
    },
  },
  getItemOffset: {
    type: Function,
    default: function($el) {
      let targetRect = $el.getBoundingClientRect()
      return {
        x: targetRect.x + targetRect.width / 2,
        y: targetRect.y + targetRect.height / 2 - 5,
      }
    },
  },
  hasTooltip: {
    type: [Function, null],
    default: null,
  },
  fontSize: {
    type: Number,
    default: 10,
    exposed: true,
  },
  onCentroid: {
    type: Boolean,
    default: false,
    exposed: true,
  },
  evolutive: {
    type: Array,
    default: [],
    exposed: true,
  },
  beforeUpdate: {
    type: Function,
    default: () => {},
    exposed: true,
  },
}

TooltipBehavior.configName = 'TooltipBehavior'
export default TooltipBehavior
